<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45">
            LENGUAS ORIGINARIAS <br>
            <span style="line-height: 100%;" class="fontMS500">
            LA PERSISTENCIA DE LA PALABRA <br>
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio32/memoria-recuperada">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio32/memoria-recuperada">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio32/memoria-recuperada">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio35/LENGUAS-000.png">
</section>

<div class="fondoBlanco_Intro" >
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS300 text-center  font-24 ">
                    <br>

                    LAS LENGUAS INDÍGENAS ENCIERRAN UN CÚMULO DE CONOCIMIENTOS, HISTORIA Y TRADICIONES
                    QUE DEFINEN LA IDENTIDAD DE LOS PUEBLOS QUE LAS HABLAN. DESAFORTUNADAMENTE,
                    MUCHAS DE ELLAS <span class="fontMS700">CORREN EL RIESGO DE DESAPARECER</span> POR UNA SERIE DE RAZONES ENTRE LAS
                    QUE DESTACAN EL RACISMO Y MARGINACIÓN EN QUE VIVEN SUS HABLANTES.
                    A PARTIR DE LA COLECCIÓN PAUL RIVET Y EL FONDO ANTIGUO DE LA BIBLIOTECA NACIONAL DEL
                    PERÚ, EL PRESENTE MICROSITIO PRESENTA UN PANORAMA DE TEXTOS RELIGIOSOS, LITERARIOS Y
                    MUSICALES EN LENGUAS ORIGINARIAS AMERICANAS, DESDE EL PERIODO VIRREINAL HASTA EL
                    NUEVO AUGE DE ESTUDIO LINGÜÍSTICO A COMIENZOS DEL SIGLO XX.
                    <br>
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoMarron">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row mt-5">
                    <div class="col-sm-6 ">
                        <p class="text-center">
                            <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                                <img width="100%"
                                    src="\assets\images\micrositio\micrositio35\LENGUAS-001.png">
                            </a>

                        </p>
                        <p class="fontMS100Italic text-left text-white font-20" >

                            Camino al Pichis. Indio shipibo. República peruana 1900 [álbum].
                            1900. Foto No. 266. 23 x 17 cm. <br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5 mt-5">
                        <p class="fontMS300 text-justify text-white font-24">
                            <br><br>
                            La presentación de estas publicaciones
                            expresan la identidad multicultural de las
                            sociedades peruanas y americanas, las
                            cuales deben ser (re)valoradas para que
                            sea la base de la construcción real de los
                            procesos de desarrollo sociocultural,
                            económico, ambiental e institucional de
                            nuestros países.
                            <br><br>
                        </p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondo1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%; margin-top: -1%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            GRAMÁTICAS, CATECISMOS Y <br>
                            VOCABULARIOS EN LENGUAS <br>
                            ORIGINARIAS: SIGLOS XVI-XVII <br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                </div>
                <p class="fontMS300 text-center font-24">
                    <br>
                    DURANTE EL SIGLO XVI, LAS IMPRENTAS REQUERÍAN AUTORIZACIÓN PARA FUNCIONAR EN EL
                    VIRREINATO DEL PERÚ. CONSIDERANDO QUE LE EVANGELIZACIÓN ERA UNA PRIORIDAD PARA LA
                    CORONA ESPAÑOLA, EL REY FELIPE II LE CONCEDE LICENCIA REAL AL IMPRESOR ITALIANO ANTONIO
                    RICARDO. ES ASÍ QUE, EN 1584, SE IMPRIME LA DOCTRINA CHRISTIANA, EL PRIMER LIBRO EN UNA
                    EDICIÓN TRILINGÜE (ESPAÑOL, QUECHUA Y AIMARA), QUE SE CONVIRTIÓ EN EL PRIMERO DE UNA
                    SERIE DE LIBROS DEDICADOS A ESA TAREA.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-3" >
                        <a href="https://hdl.handle.net/20.500.14428/34015" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-002.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000" >
                            <br><br>
                            La imprenta en Lima : 1584-1824 / José Toribio <br>
                            Medina. Tomo I.<br>
                            Disponible en:<br> <a href="https://hdl.handle.net/20.500.14428/34015" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col" ></div>
                    <div class="col-sm-3" >
                        <a href="https://hdl.handle.net/20.500.14428/13066" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-003.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000" >
                            <br><br>
                            Doctrina christiana y catecismo para<br>
                            instrvccion de los Indios... Ciudad de los reyes:<br>
                            Antonio Ricardo, 1584. – [84] h. ; 21 cm.<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/13066" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col" ></div>
                    <div class="col-sm-3" >
                        <a href="https://hdl.handle.net/20.500.14428/66064" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-004.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000" >
                            <br><br>
                            Tercero cathecismo y exposicion de la Doctrina<br>
                            Christiana, por sermones para que los cvras...<br>
                            Disponible en:<br> <a href="https://hdl.handle.net/20.500.14428/66064" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                            <br><br><br>
                        </p>
                    </div>

                </div>
                <p class="fontMS300 text-center font-20">
                    <br><br>
                    Por otro lado, entre los siglos XVI y XVII también se imprimieron vocabularios, gramáticas, catecismos y sermones que
                    contienen material lingüístico de gran valor debido a que muchos de los traductores entendieron sus obras como prueba
                    de la elocuencia de las lenguas originarias.
                    Al mismo tiempo, sus decisiones lingüísticas y estrategias expresivas subrayan los debates culturales y las tensiones
                    interculturales de ese período.<br>
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-3" >
                        <a href="https://hdl.handle.net/20.500.14428/69704" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-005.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000" >
                            <br><br>
                            Arte, y vocabulario en la lengva general del <br>
                            Perv llamada quichua, y en la lengua española<br>
                            Disponible en:<br> <a href="https://hdl.handle.net/20.500.14428/69704" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col" ></div>
                    <div class="col-sm-3" >
                        <a href="https://hdl.handle.net/20.500.14428/12968" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-006.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000" >
                            <br><br>
                            Gramatica y arte nueva de la lengua general<br>
                            de todo el Peru...<br>
                            Disponible en:<br> <a href="https://hdl.handle.net/20.500.14428/12968" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col" ></div>
                    <div class="col-sm-3" >
                        <a href="https://hdl.handle.net/20.500.14428/12065" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-007.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000" >
                            <br><br>
                            Vocabulario de la lengua aymara : primera<br>
                            parte.<br>
                            Disponible en:<br> <a href="https://hdl.handle.net/20.500.14428/12065" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                            <br><br><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoMarron">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio35/LENGUAS-LINEA-003.png" width="100%">
                <div class="row marg">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-11">
                        <p class="fontMS500 text-center font-18 text-white">
                            <br>
                            «SE HA ESCRITO YA EN NUMEROSAS OCASIONES QUE EL SIGLO XVI —PARTICULARMENTE SU SEGUNDA MITAD—
                            CONSTITUYÓ UNA EDAD DE ORO PARA LAS LENGUAS INDÍGENAS DE AMÉRICA, QUE FUERON EXAMINADAS CON ATENCIÓN Y
                            CELO, Y SOMETIDAS AL ANÁLISIS COMPARADO CON EL LATÍN Y EL CASTELLANO: FRANCISCANOS, DOMINICOS, AGUSTINOS Y,
                            MÁS TARDE, JESUITAS Y OTRAS ÓRDENES RELIGIOSAS PUSIERON EN DICHO PERÍODO UN GRAN ENTUSIASMO EN LA
                            ELABORACIÓN DE GRAMÁTICAS Y VOCABULARIOS DE LAS VARIEDADES LINGÜÍSTICAS DEL NUEVO MUNDO; NO TENÍAN
                            COMO META ESTOS RELIGIOSOS ABORDAR PROPIAMENTE UN ESTUDIO FILOLÓGICO, SINO CREAR INSTRUMENTOS QUE
                            FUERAN ÚTILES PARA LA MISIÓN QUE LE HABÍA SIDO ENCOMENDADA AL OTRO LADO DEL ATLÁNTICO: LA EVANGELIZACIÓN
                            DE LAS INDIAS. POR ELLO, COMPLEMENTARIAMENTE, TRADUJERON TEXTOS RELIGIOSOS Y ELABORARON CATECISMOS Y
                            CONFESIONARIOS EN DIVERSAS MODALIDADES LINGÜÍSTICAS AUTÓCTONAS»
                            <br>
                        </p>
                        <div class="text-right">
                            <p class="fontMS300 text-center font-16 text-white">
                                <br>
                                («LAS LENGUAS INDÍGENAS EN LA EVANGELIZACIÓN DEL PERÚ A TRAVÉS DE LA OBRA DEL PADRE ACOSTA». JOSÉ MARÍA ENGUITA UTRILLA, 1992)
                                <br>
                            </p>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-sm-1"></div>
            <div class="col-sm-1"></div>
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio35/LENGUAS-LINEA-003.png" class="reflejo"
                width="100%">
            </div>
        </div>
    </div>
</div>

<div class="fondo2">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            COLECCIÓN PAUL RIVET <br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                </div>
                <p class="fontMS700 text-center font-24">
                    <br><br><br><br>
                    EN 1957, LA BIBLIOTECA NACIONAL DEL PERÚ ADQUIRIÓ LA COLECCIÓN DEL RECONOCIDO ETNÓLOGO Y
                    AMERICANISTA FRANCÉS PAUL RIVET (1876-1958). DICHA COLECCIÓN CONTIENE MÁS DE MIL DOCUMENTOS
                    RELACIONADOS CON EL ESTUDIO DEL QUECHUA, AYMARA Y OTRAS LENGUAS ORIGINARIAS, ASÍ COMO LAS
                    CULTURAS INDÍGENAS. ENTRE ESAS PUBLICACIONES SE PUEDEN MENCIONAR GRAMÁTICAS Y CATECISMOS
                    DEL PERÍODO VIRREINAL, LIBROS BILINGÜES Y TRILINGÜES QUE, EN LA ACTUALIDAD, FORMAN PARTE DEL
                    PATRIMONIO CULTURAL DEL MUNDO.
                    <br><br>
                </p>
                <p class="fontMS100 text-center font-24">
                    <br>
                    ASIMISMO, HAY PARTITURAS, CARTILLAS PEDAGÓGICAS, POESÍAS, OBRAS DE TEATRO Y NOVELAS, ESTUDIOS
                    LINGÜÍSTICOS, HISTÓRICOS Y ARQUEOLÓGICOS. ESTOS DOCUMENTOS MANIFIESTAN LA REIVINDICACIÓN DE
                    LAS CULTURAS INDÍGENAS DESDE EL ARTE, LA LITERATURA Y LAS CIENCIAS SOCIALES EN EL SIGLO XX, NOS
                    INVITAN A REFLEXIONAR SOBRE LA IDENTIDAD NACIONAL Y RESALTAN DESAFÍOS Y TENSIONES QUE SIGUEN
                    VIGENTES EN NUESTRO PAÍS PLURICULTURAL Y PLURILINGÜE.
                    <br><br>
                </p>

                <div class="row">
                    <div class="col-sm-5 position-relative">
                        <img class="img-fluid" src="/assets/images/micrositio/micrositio35/LENGUAS-008.png" alt="Imagen">
                        <div class="overlay">
                            <p class="fontMS100Italic text-left text-white font-12">
                                [Paul Rivet] [fotografía]. [S.l. : s.n. , 19uu]. 1 fotografía :<br>
                                monocromo, gelatina, papel fibra ; 18 x 24 cm.<br>
                                Disponible en:<br>
                                <a href="https://www.bibliotecanacionaldigital.gob.cl/bnd/632/w3-article-313701.html" target="_blank" style="color: #ffffff;">https://www.bibliotecanacionaldigital.gob.cl/bnd/632/w3-article-313701.html</a>
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-1" ></div>
                    <div class="col-sm-6"  >
                        <br>
                        <div class="row p-2" style="background:  rgba(0, 0, 0, 0.7);">
                            <div class="col-sm-5 ">
                                <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-009.png">
                            </div>
                            <div class="col-sm-7">
                                <p class="fontMS100Italic text-center text-white font-12" >

                                    <br><br><br><br>
                                    Rivet, Paul, 1876-1958.<br>
                                    Bibliographie des lengues aymará et kičua<br>
                                    Disponible en:<br>
                                    <a href="https://repositoriointerculturalidad.ec/xmlui/handle/123456789/33247" target="_blank" style="color: #ffffff;">https://repositoriointerculturalidad.ec/xmlui/handle/123456789/33247</a>
                                    <br><br><br>
                                </p>
                            </div>

                        </div>
                        <br>
                        <div class="row p-2" style="background:  rgba(0, 0, 0, 0.7);">
                            <div class="col-sm-5">
                                <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-010.png">
                            </div>
                            <div class="col-sm-7">
                                <p class="fontMS100Italic text-center text-white font-12" >

                                    <br><br><br><br>
                                    Rivet, Paul, 1876-1958.<br>
                                    Coloquio sobre las ciencias del hombre / coloquio
                                    dirigido por el Prof. Paul Rivet, fundador del Museo del
                                    Hombre de París, y presidente de la delegación de
                                    Francia a la VIII Conferencia General de la UNESCO. –
                                    Montevideo: [Universidad de la República, Facultad de
                                    Humanidades y Ciencias], 1955. – iv, 50 h. : 22 cm.<br>

                                </p>
                            </div>

                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>

<div class="fondoMarron">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio35/LENGUAS-LINEA-003.png" width="100%">
                <div class="row marg">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-11">
                        <p class="fontMS500 text-center font-18 text-white">
                            <br>
                            «PAUL RIVET ES UNA FIGURA DE RELIEVE MUNDIAL QUE MERECE EL RESPECTO [SIC] UNÁNIME DE TODOS LOS QUE SE
                            DEDICAN A LA CIENCIA Y DE TODOS LOS HOMBRES DE BIEN. A ELLO LO HACE ACREEDOR SU VASTA OBRA DE SABIO; SU
                            INFATIGABLE ALIENTO QUE HA VIVIFICADO POR MUCHOS AÑOS A LA SOCIEDAD DE AMERICANISTAS DE AQUELLA CIUDAD Y
                            AL NOTABLE JOURNAL QUE ELLA EDITA; SU AGUDA SENSIBILIDAD SOCIAL; SU ALTIVA CONDUCTA DURANTE LA ÚLTIMA
                            GUERRA MUNDIAL; SU INVARIABLE SENTIDO DEMOCRÁTICO; E INCLUSIVE SU MÁS RECIENTE GIRA POR NUESTROS PAÍSES DE
                            AMÉRICA Y OTRAS REGIONES, CUANDO, A PESAR DE LA EDAD Y ABANDONANDO SUS OCUPACIONES HABITUALES, VINO A
                            TRATAR DE HACER COMPRENDER A NUESTROS PAÍSES CON VEHEMENCIA Y LUCIDEZ LOS PUNTOS DE VISTA DE FRANCIA Y SU
                            POLÍTICA EN ÁFRICA DEL NORTE»
                            <br>
                        </p>
                        <div class="text-right">
                            <p class="fontMS300 text-center font-16 text-white">
                                <br>
                                («VALOR CULTURAL Y EDUCATIVO DE LOS IDIOMAS INDÍGENAS Y LA BIBLIOTECA RIVET». JORGE BASADRE, 1960).                                <br>
                            </p>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-sm-1"></div>
            <div class="col-sm-1"></div>
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio35/LENGUAS-LINEA-003.png" class="reflejo"
                width="100%">
            </div>
        </div>
    </div>
</div>

<div class="fondo1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            QUECHUA <br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                </div>
                <p class="fontMS700 text-center font-24">
                    <br><br><br><br>
                    DE ACUERDO A LA BASE DE DATOS DE PUEBLOS INDÍGENAS U ORIGINARIOS, EL QUECHUA ES UNA FAMILIA
                    LINGÜÍSTICA, CON DIVERSAS VARIEDADES DISTRIBUIDAS EN SIETE PAÍSES DE AMÉRICA DEL SUR (PERÚ,
                    ECUADOR, COLOMBIA, BOLIVIA, ARGENTINA, CHILE Y BRASIL). SU DISTRIBUCIÓN CORRESPONDE A LOS
                    FENÓMENOS HISTÓRICOS DE EXPANSIÓN DEL IDIOMA EN EL ÚLTIMO MILENIO, CUYO PROCESO EXPLICA LA
                    EXISTENCIA DE DIVERSAS VARIANTES GEOGRÁFICAS.
                    <br><br>
                </p>
                <p class="fontMS100 text-center font-24">
                    <br>
                    SEGÚN DATOS DEL MINISTERIO DE EDUCACIÓN, EN EL PERÚ, EL QUECHUA ES CONSIDERADO UNA LENGUA
                    VITAL, AUNQUE MUCHAS DE SUS VARIEDADES, EN REALIDAD, ESTÉN EN PELIGRO O SERIO PELIGRO. HAY
                    CIERTAMENTE UNA DISMINUCIÓN SIGNIFICATIVA DE LA IMPORTANCIA RELATIVA DEL QUECHUA COMO
                    IDIOMA EN EL PAÍS.
                    <br><br>
                </p>

                <div class="row">
                    <div class="col-sm-12 position-relative">
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                            <img class="img-fluid" src="/assets/images/micrositio/micrositio35/LENGUAS-011.png" alt="Imagen">
                        </a>
                        <div class="overlay-cuzco">
                            <p class="fontMS100Italic text-center text-white font-12" >
                                <br><br>
                                Cuzco. Pared del palacio de Huaina Cápac. República peruana 1900 [álbum]. 1900.<br>
                                Foto No. 348. 23 x 17 cm. Disponible en:
                                <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color: #ffffff;">
                                    Biblioteca Digital
                                </a><br>
                            </p>
                        </div>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-sm-6 position-relative">
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                            <img class="img-fluid" src="/assets/images/micrositio/micrositio35/LENGUAS-012.png" alt="Imagen">
                        </a>
                        <div class="overlay-cuzco">
                            <p class="fontMS100Italic text-center text-white font-12" >
                                <br><br>
                                Cuzco. Tipos de naturales del país. República peruana 1900 [álbum]. 1900. Foto No<br>
                                366. 23 x 17 cm. Disponible en:
                                <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color: #ffffff;">
                                    Biblioteca Digital
                                </a><br>
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5">
                        <p class="fontMS100Italic text-left  font-18" >
                            <br><br>
                            El proceso de expansión y la consolidación del
                            quechua como idioma principal, y ya no solo como
                            lengua franca, se dio durante el período colonial.
                            Considerando que era más fácil difundir la doctrina
                            cristiana en un idioma nativo que la gente ya conocía,
                            los sacerdotes evangelizadores promovieron el
                            quechua en buena parte del territorio colonial. Es
                            muy probable que haya sido la catequización en
                            quechua, sumada al establecimiento de la doctrina
                            en las reducciones de indígenas, lo que terminó de
                            consolidar el quechua como idioma indígena
                            mayoritario en las zonas nortes del país.<br>
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="fondoMarron">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%; margin-top: -1%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            GRAMÁTICAS,<br>
                            VOCABULARIOS<br>
                            Y DICCIONARIOS<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                </div>
                <p class="fontMS700 text-center text-white font-24">
                    <br><br>
                    EL QUECHUA, EN SU CONDICIÓN DE LENGUA AMERINDIA MÁS IMPORTANTE Y DIFUNDIDA, CUENTA CON
                    MUCHAS GRAMÁTICAS, VOCABULARIOS Y DICCIONARIOS ELABORADOS, TANTO POR LINGÜISTAS COMO
                    POR AFICIONADOS. ESTAS PUBLICACIONES FUERON ELABORADAS DESDE LA LLEGADA DE LOS CRONISTAS
                    Y MISIONEROS CATÓLICOS.

                </p>
                <p class="fontMS100 text-center text-white font-24">
                    LA IMPORTANCIA DE ESTOS DOCUMENTOS RADICA EN QUE MUESTRAN LA EVOLUCIÓN DE LA LENGUA
                    QUECHUA, TOMANDO EN CUENTA -COMO SEÑALA EL ESPECIALISTA AMANCIO CHÁVEZ- QUE <<[L]AS
                    PALABRAS, QUE SON EL MEMBRETE DE TODO FENÓMENO O IDEA CONCEBIDA, EXPRESAN
                    ARBITRARIEDADES PURAMENTE CONVENCIONALIZADAS.
                    <br><br>
                </p>

                <div class="row">
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/80053" target="_blank" >
                            <img class="img-fluid" src="/assets/images/micrositio/micrositio35/LENGUAS-013.png" alt="Imagen">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12 " style="background: #000000; padding-bottom: 10%;">
                            <br><br>
                            De Torres Rubio, Diego, 1547-1638.<br>
                            Arte y vocabulario de la lengua<br>
                            quichua... Disponible en:<br>
                            <a href="http://hdl.handle.net/20.500.14428/80053" target="_blank" style="color: #ffffff;">Biblioteca Digital</a> <br>
                            </p>

                    </div>
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/80062" target="_blank">
                            <img class="img-fluid" src="/assets/images/micrositio/micrositio35/LENGUAS-014.png" alt="Imagen">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-bottom: 10%;">
                            <br><br>
                            Fernández Nodal, José.<br>
                            Elementos de gramática quichua o<br>
                            idioma de los Yncas... Disponible en:<br>
                            <a href="http://hdl.handle.net/20.500.14428/80062" target="_blank" style="color: #ffffff;">Biblioteca Digital</a> <br>
                            </p>

                    </div>
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/80048" target="_blank">
                            <img class="img-fluid" src="/assets/images/micrositio/micrositio35/LENGUAS-015.png" alt="Imagen">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-bottom: 10%;">
                            <br><br>
                            Paz Soldán, Mariano Felipe, 1821-1886.<br>
                            Diccionario geográfico estadístico del<br>
                            Perú... Disponible en:<br>
                            <a href="http://hdl.handle.net/20.500.14428/80048" target="_blank" style="color: #ffffff;">Biblioteca Digital</a> <br>
                            </p>

                    </div>
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/80068" target="_blank">
                            <img class="img-fluid" src="/assets/images/micrositio/micrositio35/LENGUAS-016.png" alt="Imagen">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12 " style="background: #000000; padding-bottom: 10%;">
                            <br><br>
                            Cordero, Luis.<br>
                            Filología: breve examen del «Compendio<br>
                            de gramática quichua»... Disponible en:<br>
                            <a href="http://hdl.handle.net/20.500.14428/80068" target="_blank" style="color: #ffffff;">Biblioteca Digital</a> <br>
                            </p>

                    </div>
                </div>

                <p class="fontMS100 text-justify text-white font-24">
                    <br><br>
                    Esta arbitrariedad es la justificación de la vida y acción humana convencionalizada. Los elementos de lengua muestran la
                    capacidad creativa y organizativa del hombre que todo lo convierte en hecho social, ninguna palabra podría existir sin cumplir
                    el fin comunicativo y por tanto un evento interindividual. La sociedad es quien admite o rechaza la cotidianización de las
                    palabras. Es, asimismo, la sociedad la que desfuncionaliza, la que analiza y la desusa».
                    <br><br>
                </p>

                <div class="row">
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/80040" target="_blank">
                            <img class="img-fluid" src="/assets/images/micrositio/micrositio35/LENGUAS-017.png" alt="Imagen">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12 " style="background: #000000; padding-bottom: 10%;">
                            <br><br>
                            Villar, Leonardo, 1825-1900.<br>
                            Lingüística nacional : estudios sobre la<br>
                            keshua... Disponible en:<br>
                            <a href="http://hdl.handle.net/20.500.14428/80040" target="_blank" style="color: #ffffff;">Biblioteca Digital</a> <br>
                            </p>

                    </div>
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/80066" target="_blank">
                            <img class="img-fluid" src="/assets/images/micrositio/micrositio35/LENGUAS-018.png" alt="Imagen">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-bottom: 10%;">
                            <br><br>
                            Gybbon Spilsbury, Joseph Henry.<br>
                            El quichua, gramática y crestomatía...<br>
                            Disponible en:<br>
                            <a href="http://hdl.handle.net/20.500.14428/80066" target="_blank" style="color: #ffffff;">Biblioteca Digital</a> <br>
                            </p>

                    </div>
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/79951" target="_blank">
                            <img class="img-fluid" src="/assets/images/micrositio/micrositio35/LENGUAS-019.png" alt="Imagen">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-bottom: 10%;">
                            <br><br>
                            Patrón Faustos, Pablo, 1855-1910.<br>
                            Origen del kechua y del aymará...<br>
                            Disponible en:<br>
                            <a href="http://hdl.handle.net/20.500.14428/79951" target="_blank" style="color: #ffffff;">Biblioteca Digital</a> <br>
                            </p>

                    </div>
                    <div class="col-sm-3">
                        <a href="http://hdl.handle.net/20.500.14428/80043" target="_blank">
                            <img class="img-fluid" src="/assets/images/micrositio/micrositio35/LENGUAS-020.png" alt="Imagen">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12 " style="background: #000000; padding-bottom: 10%;">
                            <br><br>
                            Pantigoso, Alfonso<br>
                            Origen semítico de la lengua quechua...<br>
                            Disponible en:<br>
                            <a href="http://hdl.handle.net/20.500.14428/80043" target="_blank" style="color: #ffffff;">Biblioteca Digital</a> <br>
                            </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-002.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            <br>
                        </p>
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS700 text-center colorPrincipal font-40">

                </p>
                <!-- <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-002.png">
                </div> -->
                
                <div class="row mt-5">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-2">
                                    <img src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS100Italic text-left font-14">
                                    <span class="fontMS700Italic">Arte y diccionario Qquechua-español</span> / correjido y aumentado por
                                    los RR.PP. Redentoristas ; al que en 1608 publicó el Rvdo. P. Diego
                                    González de Holguín S.J. – Lima: Imprenta del Estado, 1901. – xviii,
                                    399, 139 p. : il. ; 20 cm. Antes del título: J. M. J. A. Biblioteca
                                    Qquechua-Español.<br><br>
                                    Disponible en:
                                    <a href="http://hdl.handle.net/20.500.14428/80041" target="_blank" style="color: #000000;">Biblioteca Digital</a>
                                    <br><br>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-2">
                                    <img src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS100Italic text-left font-14">
                                    <span class="fontMS700Italic">Grigórieff, Sergio. Compendio del idioma quichua: 1. Grammatica ; 2.
                                        Diccionario quichua-castellano ; 3. Paradigmas del verbo (tablas) : con
                                        notas detalladas sobre las particularidades del idioma en Santiago del
                                        Estero</span> / Sergio Grigórieff. – Buenos Aires: Ed. Claridad, 1935. – 335 p. :
                                        il., diagrs. plegs. ; 24 cm.<br><br>
                                        Disponible en:
                                        <a href="http://hdl.handle.net/20.500.14428/80067" target="_blank" style="color: #000000;">Biblioteca Digital</a>
                                    <br><br>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-2">
                                    <img  src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS100Italic text-left font-14">
                                    <span class="fontMS700Italic">Gasparri, Henrique. La lengua qquichua y la lengua egipcia en sus
                                    tres formas: geroglífica[,] demótica y copta</span> / Henrique Gasparri. –
                                    Fascículo II. -- Bruxelles: Autographie Pepermans, 1903. – 268 p. ;
                                    21 cm.<br>
                                    Edición facsimilar del manuscrito original.<br><br>
                                    Disponible en:
                                    <a href="http://hdl.handle.net/20.500.14428/80047" target="_blank" style="color: #000000;">Biblioteca Digital</a>
                                    <br><br>
                                </p>
                            </div>
                        </div>

                    </div>
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-2">
                                    <img  src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS100Italic text-left font-14">
                                    <span class="fontMS700Italic">Dávalos, Juan Benjamín, 1874- <br>
                                        Gramática elemental de la lengua quechua</span> /  Juan Benjamín Dávalos.
                                    – Lima: Impr. Ariel, [1938]. – 103, [3] p. ; mapa ; 21 cm.
                                    «Pueblo que olvida su lengua nativa, ha perdido parte del sentido de
                                    su legítima nacionalidad. <br><br>
                                    Disponible en:
                                        <a href="http://hdl.handle.net/20.500.14428/80049" target="_blank" style="color: #000000;">Biblioteca Digital</a>
                                    <br><br>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-2">
                                <img src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS100Italic text-left font-14">
                                    <span class="fontMS700Italic">Suárez A., Humberto. El idioma de los Inkas, oficialmente se debe
                                        escribir KESWA y no Quechua</span> / Humberto Suárez A. – Lima: s.n.,
                                        1930. -- [1] h. ; 37 cm. Subtítulo: Evolución bibliográfica de este
                                        nombre. Artículo escrito en julio de 1930.<br><br>
                                        Disponible en:
                                        <a href="http://hdl.handle.net/20.500.14428/79985" target="_blank" style="color: #000000;">Biblioteca Digital</a>
                                </p>
                            </div>
                        </div>

                    </div>
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-2">
                                    <img  src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS100Italic text-left font-14">
                                    <span class="fontMS700Italic">Villar, Leonardo, 1825-1900.<br>
                                        Lingüística nacional : informe del Dr. Leonardo Villar, sobre la
                                        Gramática quechua del Dr. José D. Anchorena</span> / SLeonardo Villar. –
                                        [Lima: s.n., 1945?]. – p. 175-204, [323]-352 ; 24 cm<br><br>
                                        Disponible en:
                                        <a href="http://hdl.handle.net/20.500.14428/80058" target="_blank" style="color: #000000;">Biblioteca Digital</a>
                                    <br><br>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-2">
                                <img src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS100Italic text-left font-14">
                                    <span class="fontMS700Italic">Quechua grammar and quechua-spanish-english dictionary.</span>
                                    - [Nueva York?]: s.n., [1934]. – 319 p. ; 19 cm.<br><br>

                                    <br><br>
                                </p>
                            </div>
                        </div>

                    </div>
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-2">
                                    <img src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS100Italic text-left font-14">
                                    <span class="fontMS700Italic">Bocabulario [sic] de las voces usuales de aymara al castellano y
                                        quechua</span> – La Paz: s.n., [1946?]. – 22 p. ; 20 cm.<br><br>
                                        Disponible en:
                                        <a href="https://hdl.handle.net/20.500.14428/62251" target="_blank" style="color: #000000;">Biblioteca Digital</a>
                                    <br><br>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoMarron">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio35/LENGUAS-LINEA-003.png" width="100%">
                <div class="row marg">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-11">
                        <p class="fontMS500 text-center font-18 text-white">
                            <br>
                            «UN ASPECTO DE IMPORTANCIA CENTRAL PARA EL CONOCIMIENTO DE LA HISTORIA DE LOS PUEBLOS AMERINDIOS Y SUS
                            LENGUAS ES EL ESTUDIO DE LAS PRIMERAS DESCRIPCIONES LÉXICAS Y GRAMATICALES QUE SE HICIERON DE ESTAS. LA
                            ELABORACIÓN DE ARTES Y VOCABULARIOS DE LAS LENGUAS VERNÁCULAS DURANTE EL PERIODO COLONIAL AMERICANO ES,
                            COMO SE SABE, UNA EMPRESA DESARROLLADA EN EL MARCO DE LA EVANGELIZACIÓN DE LOS INDÍGENAS. SUS
                            RESPONSABLES FUERON RELIGIOSOS, PRINCIPALMENTE FRAILES DE DISTINTAS ÓRDENES, PREDOMINANTEMENTE JESUITAS
                            PARA EL CASO DE LAS DESCRIPCIONES DEL QUECHUA Y DEL AIMARA. ESTOS TRABAJOS SON EL RESULTADO DEL
                            RECONOCIMIENTO DE LA INSOSLAYABLE NECESIDAD DE APRENDER LAS LENGUAS ABORÍGENES PARA USARLAS COMO
                            MEDIO DE INSTRUCCIÓN Y TRANSMISIÓN DE LAS VERDADES CRISTIANAS».
                            <br>
                        </p>
                        <div class="text-right">
                            <p class="fontMS300 text-center font-16 text-white">
                                <br>
                                («GRAMÁTICAS Y VOCABULARIOS COLONIALES DEL QUECHUA Y DEL AIMARA (1560-1619)». ÁLVARO EZCURRA RIVERO Y RAÚL BENDEZÚ-ARAUJO, 2017)                            </p>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-sm-1"></div>
            <div class="col-sm-1"></div>
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio35/LENGUAS-LINEA-003.png" class="reflejo"
                width="100%">
            </div>
        </div>
    </div>
</div>

<div class="fondo2">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            EVANGELIZACIÓN <br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                </div>
                <p class="fontMS700 text-center font-24">
                    <br>
                    SOBRE EL PARTICULAR, RAÚL PORRAS BARRENECHEA, EN EL PRÓLOGO DEL VOCABULARIO DE LA LENGUA
                    GENERAL DE TODO EL PERÚ LLAMADA QQUICHUA O DEL INCA, DE DIEGO GONZÁLEZ HOLGUÍN, SEÑALÓ LO
                    SIGUIENTE:

                </p>
                <p class="fontMS100 text-center font-24">
                    <br>
                    << EL ENTUSIASMO POR EL APRENDIZAJE DEL QUECHUA ES GENERAL EN EL SIGLO XVI. ES LA GRAN TAREA
                    ORIGINAL Y CREADORA DE CAPTACIÓN DEL ALMA INDÍGENA PARA FUNDIRLA CON EL ESPÍRITU CRISTIANO Y
                    OCCIDENTAL. EN EL FONDO DE ELLA BULLEN UN SENTIMIENTO HUMANITARIO Y UNA APETENCIA HISTÓRICA.
                    LA FINALIDAD ES GANAR LAS ALMAS PARA EL CRISTIANISMO Y RECOGER A LA VEZ EL MENSAJE DE LA TIERRA.
                    LA FINALIDAD EVANGELIZADORA SE PERSIGUE CON LA CREACIÓN DE ESCUELAS Y CONVENTOS Y CON LA
                    PREDICACIÓN CONSTANTE. EL OBSTÁCULO ES LA LENGUA NATIVA.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/80039" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-021.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000" >
                            <br><br>
                            Quaderno de directorio espiritual para el <br>
                            probecho de las almas, catisismo breve para<br>
                            los Yndios de poca capacidad.<br>
                            Disponible en:<br> <a href="http://hdl.handle.net/20.500.14428/80039" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="https://hdl.handle.net/20.500.14428/80038" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-022.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000" >
                            <br><br>
                            Acta de rendición de examen de la lengua<br>
                            general de los indios del Padre Lector..<br>
                            Disponible en:<br>
                            <a href="https://hdl.handle.net/20.500.14428/80038" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="https://hdl.handle.net/20.500.14428/80063" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-023.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000" >
                            <br><br>
                            Prontuario o cartilla catequística de los<br>
                            primeros rudimentos de la fé en el idioma<br>
                            quichua...<br>
                            Disponible en:<br> <a href="https://hdl.handle.net/20.500.14428/80063" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="https://hdl.handle.net/20.500.14428/80065" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-024.png">
                        </a>
                    <p class="fontMS100Italic text-center text-white font-12" style="background: #000000" >
                        <br><br>
                        Oraciones y meditaciones, según S. Alfonso<br>
                        traducido al inca por los Pp. Redentoristas...<br>
                        Disponible en:<br> <a href="https://hdl.handle.net/20.500.14428/80065" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                        <br><br><br>
                    </p>
                </div>

                </div>
                <p class="fontMS300 text-center font-20">
                    <br><br>
                    De las dos políticas imperiales a seguir, la de exterminar la lengua indígena o la de conservarla estudiándola y aprendiéndola,
                    el español opta por la segunda. Roma no respetó la lengua ibérica ni el Islam el romance español. En Indias oscilan frente al
                    caso lingüístico incaico, las corrientes contradictorias de los juristas románicos y los teólogos católicos, pero a la postre es el
                    cura de almas, el doctrinero, el que escoge el camino más humano. Los frailes comienzan a estudiar las lenguas indígenas y
                    a captar los secretos de la civilización primitiva. Los órganos de esa actividad incansable fueron los prelados y los concilios,
                    la Universidad y las congregaciones religiosas, particularmente dominicos y jesuitas». <br>
                    <br><br>
                </p>

            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-002.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            <br>
                        </p>
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS700 text-center colorPrincipal font-40">

                </p>
                <!-- <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-002.png">
                </div> -->
                
                <div class="row mt-5">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-2">
                                <img src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS100Italic text-left font-14">
                                    <span class="fontMS700Italic">Visitas al Smo. Sacramento y María Santísima en kichua.</span> - Lima: s.n.,
                                    1893. -- [196], 99 p. ; 14 cm.<br>
                                    A la cabeza del título: Jesús, María, José, Ana, Alfonso, Rosa, Teresa y
                                    Miguel me protejan en todo para crecer en amor a Dios.<br><br>
                                    Disponible en:
                                    <a href="http://hdl.handle.net/20.500.14428/80037" target="_blank" style="color: #000000;">Biblioteca Digital</a>

                                </p>
                            </div>
                        </div>

                    </div>
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-2">
                                <img src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS100Italic text-left font-14">
                                    <span class="fontMS700Italic">Muchhaska yupaychaska cachum apu Dios, hinallatak</span> : Kollanan
                                    huiñay Virgen Mariapas, sapa ppunchau pacha-pakariyta diosta
                                    yupaychana simicuna / P. Fr. José Gregorio Castro. – Lima : Kapak
                                    Haktapi, 1904. – 15 p. ; 16 cm. <br>
                                    «Iltmo. i Rdmo. Apu Arzobispok licencianhuan pakarischiska».
                                    Contenido: Actos cristianos. Padre Nuestro. Ave María. Credo. Salve.
                                    Mandamientos. <br>
                                    Las oraciones están en quechua. <br><br>
                                        Disponible en:
                                        <a href="http://hdl.handle.net/20.500.14428/80070" target="_blank" style="color: #000000;">Biblioteca Digital</a>

                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-2">
                                <img src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS100Italic text-left font-14">
                                    <span class="fontMS700Italic">Valencia, Félix Rosario.</span> Novena en honor de la Santísima Virgen del Rosario : para implorar
                                    remedio en las mayores tribulaciones, escrita en idioma quechua /
                                    por el Presbítero Félix Rosario Valencia. – Cuzco: Impr. de M. F.<br>
                                    Minauro, 1903. – 35 p. ; 16 cm.<br><br>
                                    Disponible en:
                                    <a href="http://hdl.handle.net/20.500.14428/80069" target="_blank" style="color: #000000;">Biblioteca Digital</a>
                                    <br><br>
                                </p>
                            </div>
                        </div>

                    </div>
                    <div class="col-sm-6"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoMarron">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio35/LENGUAS-LINEA-003.png" width="100%">
                <div class="row marg">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-11">
                        <p class="fontMS500 text-center font-20 text-white">
                            <br>
                            «LA CIRCUNSTANCIA QUE PERMITIÓ EL DESARROLLO DE LA EVANGELIZACIÓN QUECHUA EN EL SIGLO XVI FUE LA EXISTENCIA
                            DE VARIANTES MUY POCO DIVERGENTES DE UN MISMO CONJUNTO DIALECTAL QUE ASEGURABAN LA INTERCOMUNICACIÓN
                            —AL MENOS, ENTRE MIEMBROS DE LAS CLASES DOMINANTES— EN LA CASI TOTALIDAD DEL TERRITORIO DEL ANTIGUO
                            IMPERIO DE LOS INCAS. SE TRATA DE LO QUE LOS LINGÜISTAS DE LA COLONIA LLAMABAN “LA LENGUA DEL INGA" O "LA
                            LENGUA DEL CUZCO", AUNQUE NO ERA NECESARIAMENTE ORIGINARIA DEL CUZCO Y SU PROPAGACIÓN NO HAYA SIDO OBRA
                            DE LOS INCAS».
                            <br>
                        </p>
                        <div class="text-right">
                            <p class="fontMS300 text-center font-16 text-white">
                                <br>
                                (EL SOL, LA LUNA Y LAS ESTRELLAS NO SON DIOS... LA EVANGELIZACIÓN EN QUECHUA (SIGLO XVI). GERALD TAYLOR, 2003)
                                <br>
                            </p>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-sm-1"></div>
            <div class="col-sm-1"></div>
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio35/LENGUAS-LINEA-003.png" class="reflejo"
                width="100%">
            </div>
        </div>
    </div>
</div>

<div class="fondo1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LITERATURA Y MÚSICA <br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                </div>
                <p class="fontMS700 text-center font-24">
                    <br>
                    EL QUECHUA ES UN IDIOMA BASTANTE EXPRESIVO QUE TIENE LAS SIGUIENTES CARACTERÍSTICAS:
                    <br><br>
                </p>

                <div class="row">
                    <div class="col-sm-4 position-relative" >

                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-CUADRO-000.png">
                        <div class="overlay-cuadro">
                            <p class="fontMS100Italic text-left text-white font16">
                                <br><br>
                                A) ES UNA LENGUA
                                AGLUTINANTE, LO QUE
                                SIGNIFICA QUE LAS
                                PALABRAS SE FORMAN
                                AÑADIENDO AFIJOS A
                                LAS RAÍCES.<br>
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-4 position-relative" >

                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-CUADROS-001.png">
                        <div class="overlay-cuadro">
                            <p class="fontMS100Italic text-left text-white font16">
                                <br><br>
                                B) POSEE UN SISTEMA
                                DE ESCRITURA BASADO
                                EN EL ALFABETO
                                LATINO, CON ALGUNAS
                                LETRAS ADICIONALES
                                PARA REPRESENTAR
                                SONIDOS QUE NO
                                EXISTEN EN OTROS
                                IDIOMAS.<br>
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-4 position-relative" >

                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-CUADROS-002.png">
                        <div class="overlay-cuadro">
                            <p class="fontMS100Italic text-left text-white font16" >
                                <br><br>
                                C) ES UNA LENGUA
                                TONAL, LO QUE
                                SIGNIFICA QUE EL
                                SIGNIFICADO DE UNA
                                PALABRA PUEDE CAMBIAR
                                DEPENDIENDO DEL TONO
                                CON EL QUE SE
                                PRONUNCIE.<br>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-4 position-relative" >
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-CUADROS-003.png">
                        <div class="overlay-cuadro">
                            <p class="fontMS100Italic text-left text-white font16">
                                <br><br>
                                D) PRESENTA UNA GRAN
                                CANTIDAD DE
                                VOCABULARIO
                                RELACIONADO CON LA
                                NATURALEZA Y LA VIDA
                                RURAL, REFLEJANDO EL
                                ESTILO DE VIDA DE LAS
                                COMUNIDADES QUECHUAS.<br>
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-4 position-relative" >
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-CUADROS-004.png">
                        <div class="overlay-cuadro">
                            <p class="fontMS100Italic text-left text-white font16" >
                                <br><br>
                                E) ES UNA LENGUA CON
                                UNA FUERTE TRADICIÓN
                                ORAL, TRANSMITIDA DE
                                GENERACIÓN EN
                                GENERACIÓN A TRAVÉS
                                DE HISTORIAS,
                                CANCIONES Y RITUALES.<br>
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-2"></div>
                </div>

                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-4 position-relative" >
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-CUADROS-005.png">
                        <div class="overlay-cuadro">
                            <p class="fontMS100Italic text-left text-white font16">
                                <br><br>
                                F) EL QUECHUA HA
                                INFLUIDO EN EL ESPAÑOL
                                HABLADO EN LA REGIÓN
                                ANDINA, DANDO LUGAR A
                                UNA SERIE DE PRÉSTAMOS
                                LINGÜÍSTICOS Y A LA
                                INFLUENCIA DE LA
                                GRAMÁTICA QUECHUA EN
                                EL ESPAÑOL REGIONAL.<br>
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-4 position-relative" >
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-CUADROS-006.png">
                        <div class="overlay-cuadro">
                            <p class="fontMS100Italic text-left text-white font16" >
                                <br><br>
                                G) EL QUECHUA ES
                                CONSIDERADO COMO UN
                                PATRIMONIO INMATERIAL
                                DE LA HUMANIDAD POR LA
                                UNESCO, LO QUE HA
                                CONTRIBUIDO A SU
                                VISIBILIZACIÓN A NIVEL
                                INTERNACIONAL.<br>
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-2"></div>
                </div>
                <div class="row">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <p class="fontMS100 text-center font-20">
                                <br><br>
                                LOS ASPECTOS SEÑALADOS PODRÁN SER APRECIADOS EN LAS DIVERSAS
                                MUESTRAS QUE SE HAN INCLUIDO EN ESTA SECCIÓN.<br>
                                <br><br>
                            </p>
                        </div>
                        <div class="col-sm-2"></div>
                </div>

                <div class="row">
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/80064" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-025.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000" >
                            <br><br>
                            Ollantay / por Clements R. Markham ; tr. del<br>
                            inglés por Adolfo F. Olivares y seguido de una<br>
                            carta crítica del doctos don Vicente...<br>
                            Disponible en:<br> <a href="http://hdl.handle.net/20.500.14428/80064" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="http://hdl.handle.net/20.500.14428/79604" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-026.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000" >
                            <br><br>
                            Rodríguez Aweranka, Eustaquio.<br>
                            Himno Nacional en quechua / traducido por el<br>
                            maestro quechua y aymara...<br>
                            Disponible en:<br>
                            <a href="http://hdl.handle.net/20.500.14428/79604" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="https://hdl.handle.net/20.500.14428/80060" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-027.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000" >
                            <br><br>
                            Valcárcel, Theodoro, 1896-1942.<br>
                            Chililin – uth´aja = Campanita de mi pueblo<br>
                            [música] / [Theodoro Valcárcel]. <br>
                            Disponible en:<br> <a href="https://hdl.handle.net/20.500.14428/80060" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                        <a href="https://hdl.handle.net/20.500.14428/80073" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-028.png">
                        </a>
                    <p class="fontMS100Italic text-center text-white font-12" style="background: #000000" >
                        <br><br>
                        Chants quechuas [manuscrito]. -- [Corculla]: s.<br>
                        n., 1930-1931. – 22 p., [2] h. ; 34 cm.<br><br>
                        Disponible en:<br> <a href="https://hdl.handle.net/20.500.14428/80073" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                        <br><br><br>
                    </p>
                </div>
                <br><br>
                <div class="row">
                    <div class="col" ></div>
                    <div class="col-sm-3" >
                            <a href="http://hdl.handle.net/20.500.14428/80055" target="_blank">
                                <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-029.png">
                            </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000" >
                            <br><br>
                            Flores, J. J., 1869-1936.<br>
                            Huámbar: poetastro acacautinaja.<br><br>
                            Disponible en:<br>
                            <a href="http://hdl.handle.net/20.500.14428/80055" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >

                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-030.png">

                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000" >
                            <br><br>
                            Plegaria al Illimani = ¡Jankko lliphipquiri<br>
                            Jillimani!<br><br><br>
                            <!-- Disponible en: <br>
                            -----xxxxxxxxxxxxxxxxxx---------------<br><br><br> --><br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-3" >

                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-031.png">

                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000" >
                            <br><br>
                            Miranda Rivera, Porfirio. <br>
                            ¡Yuyaricuai! = Acuérdate de mí [manuscrito]<br><br><br>
                            <!-- Disponible en: <br>
                            -----xxxxxxxxxxxxxxxxxx---------------<br><br><br> --><br><br><br>
                        </p>
                    </div>
                    <div class="col" ></div>
            </div>
        </div>
    </div>
</div>
</div>
</div>

<div class="fondoMarron">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio35/LENGUAS-LINEA-003.png" width="100%">
                <div class="row marg">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-11">
                        <p class="fontMS500 text-center font-18 text-white">
                            <br>
                            «DESDE FINES DEL SIGLO XVI EMPIEZA A CULTIVARSE EL QUECHUA EN FORMA ARTÍSTICA Y LITERARIA. DE LAS TRADUCCIONES
                            DE ORACIONES Y LETANÍAS CRISTIANAS DEL ESPAÑOL AL QUECHUA Y DE LAS VERSIONES DE LOS HIMNOS Y ORACIONES
                            QUECHUAS A LA LETRA ESCRITA OCCIDENTAL, COMO LO HICIERAN LAS CRÓNICAS DE MOLINA Y SARMIENTO, SE PASA A LAS
                            COMPOSICIONES ORIGINALES EN QUECHUA, RELIGIOSAS Y PROFANAS, Y SE INICIA LA COMPOSICIÓN DE COMEDIAS Y DE
                            DIÁLOGOS O COLOQUIOS PIADOSOS RIMADOS, QUE REPRESENTAN LOS INDIECILLOS CATECÚMENOS EN SU LENGUA NATIVA
                            COMO RELATA GARCILASO. E1 SIGLO XVII CONTINUARÁ PERFECCIONANDO Y AMPLIANDO EL ANÁLISIS DE LA LENGUA Y DE
                            SU ESTRUCTURA Y ACRECENTANDO EL CAUDAL DE VOCABLOS CON LOS MEJORES VOCABULARIOS, COMO SON LOS DE
                            GONZÁLEZ HOLGUÍN Y DE TORRES RUBIO, CON NUEVAS GRAMÁTICAS O ARTES Y, PARTICULARMENTE, CON SERMONES EN LOS
                            QUE SE EJERCITA LA ELEGANCIA DE LA LENGUA POR FRAILES CRIOLLOS O SE RECOGE POR EL EXTIRPADOR DE IDOLATRÍAS LA
                            LEYENDA MITOLÓGICA EN SU PRÍSTINA VERSIÓN INDÍGENA».
                            <br>
                        </p>
                        <div class="text-right">
                            <p class="fontMS300 text-center font-16 text-white">
                                <br>
                                («PRÓLOGO» DEL VOCABULARIO DE LA LENGUA GENERAL DE TODO EL PERÚ LLAMADA QQUICHUA O DEL INCA, DE DIEGO GONZÁLEZ HOLGUÍN. RAÚL
                                PORRAS BARRENECHEA, 1952).
                                <br>
                            </p>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-sm-1"></div>
            <div class="col-sm-1"></div>
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio35/LENGUAS-LINEA-003.png" class="reflejo"
                width="100%">
            </div>
        </div>
    </div>
</div>

<div class="fondo1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            AIMARA <br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                </div>
                <p class="fontMS700 text-center font-24">
                    <br><br><br>
                    LA LENGUA AIMARA ES TRADICIONALMENTE HABLADA EN LOS DEPARTAMENTOS DE PUNO, MOQUEGUA Y
                    TACNA, AUNQUE POR EFECTO DE LA MIGRACIÓN GRANDES GRUPOS AIMARAHABLANTES VIVEN HOY
                    TAMBIÉN EN LIMA, AREQUIPA Y MADRE DE DIOS. ASIMISMO, ESTA LENGUA ES HABLADA EN BOLIVIA Y EL
                    NORTE DE ARGENTINA Y CHILE.
                </p>
                <p class="fontMS100 text-center font-24">
                    <br>
                    EL RECONOCIMIENTO DE ESTA LENGUA SE REMONTA A LOS TIEMPOS DEL VIRREY FRANCISCO DE TOLEDO
                    QUIEN, A RAÍZ DE LA VISITA GENERAL REALIZADA ENTRE 1570 Y 1575, OFICIALIZÓ EL AÑO 1573 A LAS TRES
                    PRINCIPALES LENGUAS PERUANAS-QUECHUA, AIMARA Y PUQUINA-CON EL NOMBRE DE << LENGUA
                    GENERAL>>. DEL MISMO MODO, TAMBIÉN SE MENCIONA A OTRAS LENGUAS COMO URUQUILLA, MOCHICA,
                    CULLI Y TALLÁN. EL DOCUMENTO FUE ENCONTRADO POR BOUYSSE-CASSAGNE EN 1975.<br><br>
                </p>

                <div class="row">
                    <div class="col-sm-12" >
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-043.png">
                        </a>
                            <p class="fontMS100Italic text-center text-white font-16" style="background: #000000;">
                                <br><br>
                                Lago Titicaca. Balsas de cañas hechas por los naturales del país. República peruana<br>
                                1900 [álbum]. 1900. Foto No. 308. 23 x 17 cm. <br>
                                Disponible en:
                                <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color: #ffffff;">Biblioteca Digital</a><br>
                                <br><br>
                            </p>

                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-5">
                        <p class="fontMS100 text-justify  font-18">
                            <br><br>
                            Similar reconocimiento se dio también en 1975,
                            con el gobierno militar de Juan Velasco Alvarado,
                            en el que hubo intención de promover las lenguas
                            andinas; sin embargo, esa política no tuvo muchos
                            resultados. <br>
                            Por su parte, en el articulo 48° de la Constitución
                            vigente, se declara que son «idiomas oficiales el
                            castellano y, en las zonas donde predominen,
                            también lo son el quechua, el aimara, y los demás
                            lenguas aborígenes».<br>
                            Según el lingüista Felipe Huayra Pari, en su trabajo
                            «Vitalidad de la lengua aimara», los aimaras tienen
                            «la identidad en la lengua y cultura, en la persona,
                            en la tierra, en la religión y en las costumbres;
                            esto nos identifica a los miembros de la nación
                            aimara expresados y codificados por símbolos
                            comunes que son el alma, el espíritu, la afirmación
                            de esa identidad, o la sustancia entretejida que
                            nos liga en la cosmovisión andina».<br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-6">
                        <a  href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-044.png">
                        </a>
                            <p class="fontMS100Italic text-center text-white font-16" style="background: #000000;">
                                <br><br>
                                Lago Titicaca. Vista general desde el Desaguadero. República peruana 1900 [álbum].
                                1900. Foto No. 306. 23 x 17 cm.<br>
                                <a  href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color: #ffffff;">Disponible en: Biblioteca Digital</a>
                                <br> <br>
                            </p>


                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-3">
                        <a  href="http://hdl.handle.net/20.500.14428/80054" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-032.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-16" style="background: #000000;">
                            <br><br>
                            De Torres Rubio, Diego, 1547-1638.
                            Arte y vocabulario de la lengua
                            quichua... Disponible en: <br>
                            <a  href="http://hdl.handle.net/20.500.14428/80054" target="_blank" style="color: #ffffff;">Biblioteca Digital</a><br> <br>
                        </p>
                    </div>
                    <div class="col-sm-3" >
                            <a  href="http://hdl.handle.net/20.500.14428/80061" target="_blank">
                                <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-033.png">
                            </a>

                            <p class="fontMS100Italic text-center text-white font-16" style="background: #000000;">
                                <br><br>
                                Fernández Nodal, José.<br>
                                Elementos de gramática quichua o
                                idioma de los Yncas... Disponible en:<br>
                                <a  href="http://hdl.handle.net/20.500.14428/80061" target="_blank" style="color: #ffffff;">Biblioteca Digital</a><br> <br>
                            </p>
                    </div>
                    <div class="col-sm-3" >
                        <a  href="https://hdl.handle.net/20.500.14428/62664" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-034.png">
                        </a>

                        <p class="fontMS100Italic text-center text-white font-16" style="background: #000000;">
                            <br><br>
                            Paz Soldán, Mariano Felipe, 1821-1886.<br>
                            Diccionario geográfico estadístico del <br>
                            Perú... Disponible en: <br>
                            <a  href="https://hdl.handle.net/20.500.14428/62664" target="_blank" style="color: #ffffff;">Biblioteca Digital</a><br> <br>


                        </p>
                    </div>
                    <div class="col-sm-3">
                        <a  href="http://hdl.handle.net/20.500.14428/80071" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-035.png">
                        </a>

                        <p class="fontMS100Italic text-center text-white font-16" style="background: #000000;">
                            <br>
                            Cordero, Luis.<br>
                            Filología: breve examen del «Compendio
                            de gramática quichua»... Disponible en: <br>
                            <a  href="http://hdl.handle.net/20.500.14428/80071" target="_blank" style="color: #ffffff;">Biblioteca Digital</a><br> <br>


                        </p>
                    </div>
                </div>


        </div>
    </div>
</div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-002.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            <br>
                        </p>
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS700 text-center colorPrincipal font-40">

                </p>
                <!-- <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-002.png">
                </div> -->
                
                <div class="row mt-5">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-2">
                                <img src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS100Italic text-left font-14">
                                    <span class="fontMS700Italic">Vocabulario y manual de conversación aimará, castellano y quechua.</span> – Edición cuidado-samente revisada, corregida y aumentada con
                                    varios capítulos que tratan de los colores, división del tiempo,
                                    propiedades del cuerpo humano, etc. etc. y gran número de frases
                                    usuales y conversación indispensable al viajero en Bolivia. -- La Paz:<br>
                                    Impr. y Litografía Andina, 1911. – 44 p. ; 20 cm.<br><br>
                                    Disponible en:<br>
                                    <a href="http://hdl.handle.net/20.500.14428/80072" target="_blank" style="color: #000000;">Biblioteca Digital</a>

                                </p>
                            </div>
                        </div>

                    </div>
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-2">
                                <img src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS100Italic text-left font-14">
                                    <span class="fontMS700Italic">Febres Cordero, Tulio, 1860-1938.</span> Historia de los Andes : procedencia y lengua de los aborígenes / Tulio
                                    Febres Cordero. – Mérida, Venezuela: Tip. El Lápiz, 1921. – 170 p. ; 13
                                    cm.<br>
                                    Contenido: Idea general del territorio. Tiempos prehistóricos.
                                    Primitivos habitantes. Indios del tiempo de la Conquista. Distribución
                                    geográfica de las tribus. Lenguas indígenas. Ortología andina.
                                    Numeración de las lenguas andinas. Vocabulario general. Nombres
                                    territoriales.<br><br>
                                    Disponible en:<br>
                                    <a href="http://hdl.handle.net/20.500.14428/80056" target="_blank" style="color: #000000;">Biblioteca Digital</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-2">
                                <img  src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS100Italic text-left font-14">
                                    <span class="fontMS700Italic">Durand, Juan E., 1873-1930.</span> NEtimologías Perú Bolivianas / por Juan Durand. – La Paz: Talleres
                                    Gráficos La Prensa, 1921. – 213 p. ; 25 cm.<br>
                                    Contenido: Etimologías de diversos idiomas como aimara, quechua,
                                    mochica, pano, aullagas, entre otros. <br><br>
                                    Disponible en:<br>
                                    <a href="http://hdl.handle.net/20.500.14428/80052" target="_blank" style="color: #000000;">Biblioteca Digital</a>

                                </p>
                            </div>
                        </div>

                    </div>
                    <div class="col-sm-6">

                            <div class="row">
                                <div class="col-sm-2">
                                    <img src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                                </div>
                                <div class="col-sm-10">
                                    <p class="fontMS100Italic text-left font-14">
                                        <span class="fontMS700Italic">Puspacha kollan suma arunaca qhitatanacan luratanacapampi.</span> -- New
                                        York : Biblia americanquiri tanthapiwi, 1941. – 178, 178 p. ; 19 cm.
                                        Esta publicación contiene los cuatro Evangelios y los Hechos de los
                                        apóstoles en español y aymara.<br>
                                        Texto a dos columnas.<br><br>
                                        Disponible en:<br>
                                        <a href="https://hdl.handle.net/20.500.14428/71658" target="_blank" style="color: #000000;">Biblioteca Digital</a>
                                    </p>
                                </div>
                            </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoMarron">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio35/LENGUAS-LINEA-003.png" width="100%">
                <div class="row marg">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-11">
                        <p class="fontMS500 text-center font-18 text-white">
                            <br>
                            «LOS AIMARAS HAN RESISTIDO CERCA DE 478 AÑOS, EN DIFERENTES FORMAS, YA SEA INCONSCIENTE O CONSCIENTEMENTE,
                            SIGUIENDO UNA TRAYECTORIA QUE DEMUESTRA VITALIDAD. CON LA PRESENCIA CADA VEZ MÁS FUERTE DE UNA
                            GLOBALIZACIÓN QUE PRETENDE LA MUNDIALIZACIÓN CULTURAL EN TORNO A LA HOMOGENIZACIÓN, HAN SURGIDO
                            NUEVOS CUESTIONAMIENTOS SOBRE LO QUE SIGNIFICAN LAS RELACIONES QUE DEBEMOS ESTABLECER ENTRE NOSOTROS;
                            AQUÍ SE HACE EVIDENTE LA NECESIDAD DE UN ENFOQUE DE INTERCULTURALIDAD COMO EXPRESIÓN DE RESPETO,
                            TOLERANCIA, INTERCAMBIO Y DIÁLOGO PRODUCTIVO CON EL OTRO, ESTABLECIENDO UNA RELACIÓN EN LA QUE TODOS
                            APORTAN A TODOS, EN LA QUE LA PRESENCIA DE LA INTERDEPENDENCIA DE LOS PUEBLOS NOS ENRIQUECE A TODOS Y
                            NOS LLEVA A VIVIR EN ARMONÍA. LA INTERCULTURALIDAD DEBE APLICARSE A LA VIDA COTIDIANA Y A LA
                            EDUCACIÓN EN FORMA TRANSVERSAL; Y QUIENES VAN A SER PROMOTORES DE ESTE PRINCIPIO DE CONVIVENCIA
                            DEBEN PLANTEARSE DESDE EL PRIMER MOMENTO LA NECESIDAD DE MANTENER UNA LÍNEA EQUILIBRADA».
                            <br>
                        </p>
                        <div class="text-right">
                            <p class="fontMS300 text-center font-16 text-white">
                                <br>
                                («VITALIDAD DE LA LENGUA AIMARA». FELIPE HUAYHUA PARI, 2013)
                                <br>
                            </p>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-sm-1"></div>
            <div class="col-sm-1"></div>
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio35/LENGUAS-LINEA-003.png" class="reflejo"
                width="100%">
            </div>
        </div>
    </div>
</div>

<div class="fondo1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LENGUAS ORIGINARIAS<br>
                            AMAZÓNICAS<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                </div>
                <p class="fontMS300 text-center font-24">
                    <br>
                    DE ACUERDO A LA BASE DE DATOS DE PUEBLOS INDÍGENAS U ORIGINARIOS DEL MINISTERIO DE CULTURA, A
                    LA FECHA EXISTEN 43 LENGUAS ORIGINARIAS AMAZÓNICAS: ACHUAR, AMAHUACA, ARABELA, ASHANINKA,
                    AWAJÚN, BORA, CAPANAHUA, CASHINAHUA, CHAMICURO, ESE EJA, HARAKBUT, IÑAPARI, IQUITU,
                    ISCONAHUA, KAKATAIBO, KAKINTE, KANDOZI-CHAPRA, KUKAMA-KUKAMIRIA, MADIJA (CULINA), MAIJUNA,
                    MATSIGENKA, MATSES, MUNICHE, MURUI-MUINAMI, NANTI, NOMATSIGENGA, OCAINA, OMAGUA,
                    RESÍGARO, SECOYA, SHARANAHUA, SHAWI, SHIPIBO-KONIBO, SHIWILU, TAUSHIRO, TIKUNA (TICUNA),
                    URARINA, WAMPIS, YAGUA, YAMINAHUA, YANESHA, YINE Y YORA (NAHUA).
                </p>
                <div class="row">
                    <div class="col-sm-4" ></div>
                    <div class="col-sm-4" >
                        <p class="fontMS100 text-center font-18">
                            <br>
                            El estudio de las lenguas amazónicas conlleva
                            una serie de dificultades originadas por las
                            siguientes situaciones:<br><br>
                        </p>
                    </div>
                    <div class="col-sm-4" ></div>
                </div>
                <div class="row">
                    <div class="col-sm-2" ></div>
                    <div class="col-sm-8 text-center" >
                        <div style="position: relative; display: inline-block; width: 70%; " >
                            <img width="70%" src="/assets/images/micrositio/micrositio35/LENGUAS-CUADROS-007.png" style="width: 100%;">
                            <p class="fontMS100 text-center text-white font18" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); margin: 0; width: 75%;">
                                Escasez de materiales.
                            </p>
                        </div>
                        <div style="position: relative; display: inline-block; width: 80%;">
                            <img width="80%" src="/assets/images/micrositio/micrositio35/LENGUAS-CUADROS-008.png" style="width: 100%;">
                            <p class="fontMS100 text-left text-white font18" style="position: absolute; top: 50%; left: 55%; transform: translate(-50%, -50%); margin: 0; width: 85%;">
                                Panorama complicado de familias lingüísticas,
                                subfamilias, dialectos, que evidencian una riqueza
                                lingüística sobresaliente.
                            </p>
                        </div>
                        <div style="position: relative; display: inline-block; width: 90%;">
                            <img width="90%" src="/assets/images/micrositio/micrositio35/LENGUAS-CUADROS-009.png" style="width: 100%;">
                            <p class="fontMS100 text-left text-white font18" style="position: absolute; top: 50%; left: 55%; transform: translate(-50%, -50%); margin: 0; width: 85%;">
                                Limitado interés hacia la lingüística aplicada pese a la
                                importancia que tiene para resolver problemas prácticos.
                            </p>
                        </div>
                        <div style="position: relative; display: inline-block; width: 100%;">
                            <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-CUADROS-010.png" style="width: 100%;">
                            <p class="fontMS100 text-left text-white font18" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); margin: 0; width: 85%;">
                                Necesidad de planificar los estudios de la problemática lingüística de la
                                Amazonía, destinada a dar respuesta a una diversidad de problemas
                                como la educación bilingüe, la interculturalidad, el estudio de normas
                                regionales, la revitalización y la extinción de las lenguas, entre otros
                                aspectos
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-2" ></div>
                </div>

                <br><br>
            <div class="row">
                <div class="col-sm-6">
                    <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-036.png">
                    </a>
                    <p class="fontMS100 text-center text-white font-18 " style="background: rgba(0, 0, 0, 0.7); padding: 4%;">
                        Camino al Pichis. Indios Lorenzos. República peruana 1900 [álbum].<br>
                        1900. Foto No. 267. 23 x 17 cm.<br>
                        Disponible en:
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                    </p>
                </div>
                <div class="col-sm-6">
                    <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-037.png">
                    </a>
                    <p class="fontMS100 text-center text-white font-18" style="background: rgba(0, 0, 0, 0.7); padding: 2%;">
                        Camino al Pichis. Indios campas. República peruana 1900 [álbum]. 1900.<br>
                        Foto No. 256. 23 x 17 cm.<br>
                        Disponible en:
                        <a href="http://hdl.handle.net/20.500.14428/78954" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>
                    </p>
                </div>
            </div>

            <div class="row" style="margin-top: 5%; background: rgba(0, 0, 0, 0.7);">
                <div class="col-sm-4" style="padding: 0;">
                    <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-045.png">
                </div>
                <div class="col-sm-8" style="padding: 0;">
                        <p class="fontMS100 text-left text-white font-18" style=" padding: 10%;">
                            Uno de los más importantes estudiosos de las lenguas
                            amazónicas fue el dominico José Pío Aza (Pola de Lena, Asturias,
                            España, 1865-Quillabamba, Cuzco, 1938) quien fue uno de los
                            más principales organizadores de las misiones de San Luis del
                            Manu, San Jacinto de Puerto Maldonado y San José de Koribeni.
                            Asimismo, se debe destacar el aporte cientifico de José Pío Aza:
                            escribió articulos sobre geogratia, historia, etnogratia y,
                            especialmente, lingüística, área en la que publica tres
                            vocabularios y una gramática. <br><br>
                            Retrato de José Pio Aza (1965-1938)
                        </p>
                </div>
            </div>

            <div class="row" style="margin-top: 5%;">
                <div class="col-sm-3">
                    <a href="http://hdl.handle.net/20.500.14428/80074" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-039.png">
                    </a>

                    <p class="fontMS100Italic text-center text-white font-16" style="background: #000000; padding: 5%;">

                        Arte de la lengua cholona / [Pedro de la
                        Mata]. – Buenaventura del Calle, Colombia:<br>
                        s.n., [1772]. – 135 p. ; 22 x 30 cm.<br>
                        <a href="http://hdl.handle.net/20.500.14428/80074" target="_blank" style="color: #ffffff;">Biblioteca Digital</a><br> <br>

                    </p>
                </div>
                <div class="col-sm-3" >
                    <a href="http://hdl.handle.net/20.500.14428/80046" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-040.png">
                    </a>

                        <p class="fontMS100Italic text-center text-white font-16" style="background: #000000; padding: 5%;">

                            Vocabulario de la lengua general de los indios<br>
                            del Putumayo y Caquetá : publicado con una...<br>
                            Disponible en: <br>
                            <a href="http://hdl.handle.net/20.500.14428/80046" target="_blank" style="color: #ffffff;">Biblioteca Digital</a><br> <br>

                        </p>
                </div>
                <div class="col-sm-3" >
                    <a href="https://hdl.handle.net/20.500.14428/62594" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-041.png">
                    </a>

                    <p class="fontMS100Italic text-center text-white font-16" style="background: #000000; padding: 5%;">

                        Estudio sobre la lengua machiguenga / por el<br>
                        P. Misionero José Pío Aza.<br>
                        Disponible en: <br>
                        <a href="https://hdl.handle.net/20.500.14428/62594" target="_blank" style="color: #ffffff;">Biblioteca Digital</a><br> <br>

                    </p>
                </div>
                <div class="col-sm-3">
                    <a href="http://hdl.handle.net/20.500.14428/80057" target="_blank">
                        <img width="100%" src="/assets/images/micrositio/micrositio35/LENGUAS-042.png">
                    </a>

                    <p class="fontMS100Italic text-center text-white font-16" style="background: #000000; padding: 5%;">

                        Vocabulario español-machigüenga / José<br>
                        Pío Aza <br>
                        Disponible en: <br>
                        <a href="http://hdl.handle.net/20.500.14428/80057" target="_blank" style="color: #ffffff;">Biblioteca Digital</a><br> <br>

                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-002.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            <br>
                        </p>
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS700 text-center colorPrincipal font-40">

                </p>
                <!-- <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-002.png">
                </div>
                <br><br> -->
                <div class="row mt-5">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-2">
                                <img  src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS100Italic text-left font-14">
                                    <span class="fontMS700Italic">Aza, José Pío, O. P., 1865-1911.</span> <br>
                                    Vocabulario español-huarayo… (con aprobación eclesiástica y de la
                                    Orden) / O. P. José Pío Aza de la Orden de Predicadores. – Lima: Impr.
                                    Americana, 1928. – 102 p. ; 24 cm.<br>
                                    Del Boletín de la Sociedad Geográfica de Lima.<br>
                                    <br>
                                    Disponible en: <br>
                                    <a href="http://hdl.handle.net/20.500.14428/80059" target="_blank" style="color:#000000;">Biblioteca Digital</a>
                                </p>
                            </div>
                        </div>

                    </div>
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-2">
                                <img  src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS100Italic text-left font-14">
                                    <span class="fontMS700Italic">Aza, José Pío, O. P., 1865-1911</span> <br>
                                    Doctrina cristiana en machiguenga y español / por el M. R. P. Fr. José
                                    Pío Aza, misionero dominico del Urubamba y Madre de Dios, Perú. –
                                    Lima: Sanmarti y Cía, 1933. – 69 p. : il. ; 17 cm
                                    <br><br>
                                    Disponible en: <br>
                                    <a href="http://hdl.handle.net/20.500.14428/80059" target="_blank" style="color: #000000;">Biblioteca Digital</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-2">
                                <img  src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS100Italic text-left font-14">
                                    <span class="fontMS700Italic">Aza, José Pío, O. P., 1865-1911</span><br>
                                    Vocabulario Español-Arasairi / por el P. Fr. José Pío Aza de la Orden
                                    de Predicadores. – Lima: Sanmarti y Cia., [1936]. – 36 p. ; 22 cm.
                                    Incluye «Notas aclaratorias» del Fr. S. Sarasola, Obispo y Vic.
                                    Apostólico.<br>
                                    Contenido: La tribu Arasairi y su idioma. Vocabulario
                                    Español-Arasairi. <br><br>
                                    Disponible en: <br>
                                    <a href="http://hdl.handle.net/20.500.14428/79950" target="_blank" style="color: #000000;">Biblioteca Digital</a>
                                </p>
                            </div>
                        </div>

                    </div>
                    <div class="col-sm-6">

                            <div class="row">
                                <div class="col-sm-2">
                                    <img src="\assets\images\micrositio\micrositio35\LENGUAS-ICONO-000.png">
                                </div>
                                <div class="col-sm-10">
                                    <p class="fontMS100Italic text-left font-14">
                                        <span class="fontMS700Italic">Cartilla matsigenka sankevanti I : clase de transición, zona selva,
                                            machiguenga</span> -- [Lima]: Ministerio de Educación Pública, Instituto
                                            Lingüístico de Verano, [1950]. -- 31 p. : il. ; 23 cm
                                        <br><br>
                                        Disponible en: <br>
                                    <a href="http://hdl.handle.net/20.500.14428/80044" target="_blank" style="color: #000000;">Biblioteca Digital</a>
                                    </p>
                                </div>
                            </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoMarron">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio35/LENGUAS-LINEA-003.png" width="100%">
                <div class="row marg">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-11">
                        <p class="fontMS500 text-center font-18 text-white">
                            <br>
                            «POR ERROR, DESCONOCIMIENTO Y TAMBIÉN POR PREJUICIOS, MUCHAS PERSONAS CONSIDERAN COMO LENGUA AQUELLO
                            QUE ES OCCIDENTAL Y POSEE GRAN CANTIDAD DE HABLANTES, O TIENE UN RECONOCIMIENTO Y VALORACIÓN SOCIAL
                            POSITIVA; EN OPOSICIÓN A DIALECTO, QUE ES CONSIDERADO TODO LO CONTRARIO (ORIGINARIO, MENOS HABLANTES Y CON
                            MENOR PRESTIGIO). LO CIERTO ES QUE LAS LENGUAS SON SISTEMAS LINGÜÍSTICOS USADOS PARA COMUNICARSE Y
                            PERTENECEN A UNA COMUNIDAD, MIENTRAS QUE LOS DIALECTOS SON VARIEDADES DE ESAS LENGUAS PROPIAS DE UN
                            ESPACIO GEOGRÁFICO. POR TANTO, EN EL PERÚ EXISTEN MUCHAS LENGUAS Y ALGUNAS TIENEN VARIEDADES GEOGRÁFICAS.
                            ES TAN VÁLIDO DECIR LENGUA CASTELLANA COMO LENGUA AWAJÚN, SHIPIBO, NOMATSIGUENGA, SHAWI, AIMARA, ETC.; Y
                            SUS VARIEDADES DIALECTALES AIMARA DE MOQUEGUA O AWAJÚN DE CAJAMARCA Y CASTELLANO DE AREQUIPA, POR
                            EJEMPLO».
                            <br>
                        </p>
                        <div class="text-right">
                            <p class="fontMS300 text-center font-16 text-white">
                                <br>
                                («VARIACIÓN SOCIOLINGÜÍSTICA E INTERCULTURALIDAD EN LAS LENGUAS AMAZÓNICAS». NAZARIO AGUIRRE BAIQUE ET AL. 2022)
                                <br>
                            </p>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-sm-1"></div>
            <div class="col-sm-1"></div>
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio35/LENGUAS-LINEA-003.png" class="reflejo"
                width="100%">
            </div>
        </div>
    </div>
</div>

<div class="fondo1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            VISIBILIZACIÓN Y RECONOCIMIENTO:<br>
                            MAPA DE LENGUAS INDÍGENAS<br>
                            U ORIGINARIAS VIGENTES<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio35\LENGUAS-LINEA-000.png">
                </div>
                <p class="fontMS500 text-justify font-24">
                    <br>
                    EL PERÚ ES UNO DE LOS PAÍSES MÁS DIVERSOS LINGÜÍSTICAMENTE EN AMÉRICA LATINA, HOGAR DE
                    UNA RIQUEZA CULTURAL EXPRESADA A TRAVÉS DE SUS LENGUAS INDÍGENAS U ORIGINARIAS. EL
                    PRESENTE MAPA DESTACA LAS LENGUAS VIVAS DE TODO EL TERRITORIO NACIONAL, DESDE LAS COSTAS
                    DEL PACÍFICO, PASANDO POR LOS ANDES, HASTA LA AMAZONÍA, Y NOS INVITA A REFLEXIONAR SOBRE
                    SU VALOR COMO PATRIMONIO CULTURAL QUE CONECTA A LAS COMUNIDADES CON SU HISTORIA,
                    TERRITORIO Y CONOCIMIENTO ANCESTRAL.
                    <br>
                </p>
                <p class="fontMS100 text-justify font-24">
                    <br><br>
                    LA VISIBILIZACIÓN DE ESTAS LENGUAS ES UN PASO FUNDAMENTAL PARA SU PRESERVACIÓN, EN UN
                    CONTEXTO EN EL QUE SE REALIZAN ESFUERZOS PARA REVITALIZARLAS, CON EL FIN DE CONTRIBUIR A LA
                    PROTECCIÓN DE NUESTRAS DIVERSAS EXPRESIONES LINGÜISTICAS. EL RECONOCIMIENTO OFICIAL DE
                    ESTAS LENGUAS NO SOLO REIVINDICA LA IDENTIDAD Y LOS DERECHOS DE LOS PUEBLOS ORIGINARIOS,
                    SINO QUE TAMBIÉN FORTALECE LA DIVERSIDAD CULTURAL DEL PAÍS.
                    <br><br>
                </p>

                <div class="row">
                    <div class="col-sm-6" style="text-align: center;">
                        <br><br><br>
                        <img width="100%" src="\assets\images\micrositio\micrositio35\LENGUAS-046.png">
                        <br><br><br>
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/mapa-lenguas-vigentes-peru.pdf" target="_blank" >
                            <img class="tamaño" src="\assets\images\micrositio\micrositio35\LENGUAS-047.png">
                            <br><br>
                        </a>
                    </div>
                    <div class="col-sm-6" >
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/mapa-lenguas-vigentes-peru.pdf" target="_blank">
                            <img width="100%" src="\assets\images\micrositio\micrositio35\LENGUAS-048.png">
                        </a>
                        <p class="fontMS300Italic text-center text-white font-12" style="background: rgba(0, 0, 0, 0.7); padding: 4%;">

                            Mapa elaborado por la Base de Datos de Pueblos Indígenas u Originarios (BDPI) en
                            el marco de la Ley N º 29735 : Ley que regula el uso, preservación, desarrollo,
                            recuperación, fomento y difusión de las lenguas originarias del Perú
                        </p>
                    </div>
                </div>


        </div>
    </div>
</div>
</div>



<div class="fondoOrange">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-3">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS700 text-white font-40">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-9">
                        <P class="font-24 text-center text-white fontMS300Italic mt-5">

                        </P>
                        <img width="100%"
                            src="/assets/images/micrositio/micrositio35/LENGUAS-LINEAS-005.png">
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            ¿Qué impacto tiene el uso de
                            lenguas originarias en la
                            preservación de las culturas y
                            tradiciones de los pueblos
                            originarios?
                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio35/LENGUAS-LINEAS-006.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            ¿Por qué el uso de las lenguas
                            originarias ha sido históricamente
                            marginado y discriminado en
                            muchos países?
                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio35/LENGUAS-LINEAS-006.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            ¿Cuáles son algunos de los
                            principales desafíos que
                            enfrentan los pueblos originarios
                            para preservar su lengua y cultura
                            en el contexto actual?
                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio35/LENGUAS-LINEAS-006.png">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio35/LENGUAS-LINEAS-007.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio35/LENGUAS-LINEAS-007.png">
                    </div>
                </div>
                <p class="fontMS100 font-24">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6" style="overflow: hidden; word-wrap: break-word;">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Chávez, A. (2002). </span>
                            <span class="fontMS100 text-gris">Un nuevo diccionario quechua
                                como necesidad social. Escritura y Pensamiento. Vol.
                                5, no. 11, p. [91]-99 <br><br>
                                Disponible en:
                            </span>
                            <span class="text-gris"></span>
                            <a href="https://revistasinvestigacion.unmsm.edu.pe/index.php/letras/article/view/7597/6611"
                            target="_blank" style="color: #000000;">
                            https://revistasinvestigacion.unmsm.edu.pe/index.php/letras/article/view/7597/6611
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Huayhua Pari, F. (2013). </span>
                            <span class="fontMS100 text-gris">Vitalidad de la lengua aimara.
                                Revista Lengua y Sociedad. Vol. 13, no. 1, p. 25-40.</span>
                                <br><br>
                                Disponible en:
                            <span class="text-gris"></span><br>
                            <a href="https://revistasinvestigacion.unmsm.edu.pe/index.php/lenguaysociedad/article/view/22623/18022"
                            target="_blank" style="color: #000000;">
                            https://revistasinvestigacion.unmsm.edu.pe/index.php/lenguaysociedad/article/view/22623/18022
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Luna García, R. y Sánchez Tafur, C. (2019).</span>
                            <span class="fontMS100 text-gris">Diccionario
                                básico de educación e inclusión lingüística peruana.
                                Lima: Universidad Femenina del Sagrado Corazón.</span>
                            <span class="text-gris"> </span><br>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Mamani Apaza, W. y Vilca Apaza, H. (2018).</span>
                            <span class="fontMS100 text-gris">Interculturalidad y lenguas originarias en el Perú.
                                Lima: William Mamani Apaza (editor).
                                </span>
                            <span class="text-gris"> </span><br>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Mujica Bermúdez, L. (2021).</span><br>
                            <span class="fontMS100 text-gris">Muhun / Memoria:
                                Congreso Internacional en Lenguas Originarias,
                                sasachapkuy pachapi. RIMARISUM PERÚ 2020; 29, 20
                                y 31 de octubre de 2020. Apurímac: Universidad
                                Nacional José María Arguedas.
                                </span>
                            <span class="text-gris"> </span><br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Dirección General de Educación Intercultural, Bilingüe
                                y Rural (2014).</span><br>
                            <span class="fontMS100 text-gris">Documento Nacional de lenguas
                                originarias del Perú: versión resumida. Lima:
                                Dirección General de Educación Intercultural, Bilingüe
                                y Rural.
                            </span><br><br>
                            <span class="text-gris"> </span><br>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Ezcurra Rivero, A. y Bendezú-Araujo, R. (2017).</span><br>
                            <span class="fontMS100 text-gris">Gramáticas y vocabularios coloniales del quechua y
                                del aimara (1560-1619). En: Literaturas orales y
                                primeros textos coloniales. Juan C. Godenzzi y Carlos
                                Garatea, coordinadores. Lima: Pontificia Universidad
                                Católica del Perú, Fondo Editorial: Casa de la
                                Literatura: Ministerio de Educación del Perú ; (Historia
                                de las literaturas en el Perú / Raquel Chang Rodríguez
                                y Marcel Velázquez Castro, directores generales; 1).</span>
                                <br><br>
                                Disponible en:
                            <span class="text-gris"> </span><br>
                            <a href="https://www.casadelaliteratura.gob.pe/wp-content/u
                            ploads/2017/04/Historia-de-la-literatura-Vol-1-1.pdf" target="_blank" style="color: #000000;">
                            https://www.casadelaliteratura.gob.pe/wp-content/uploads/2017/04/Historia-de-la-literatura-Vol-1-1.pdf
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Porras Barrenechea, R. (1989).</span><br>
                            <span class="fontMS100 text-gris">
                                Prólogo. En: González
                                Holguín, D. Vocabulario de la lengua general de todo
                                el Perú llamada lengua qquichua o del inca. Tercera
                                edición. Lima: Universidad Nacional Mayor de San
                                Marcos, CONCYTEC.
                            </span>
                            <span class="text-gris"> </span><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>